import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF, GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { FlattenedAavoGridColDef } from "src/components/common/dataGrid/types.tsx";

/**
 * Returns a detail panel toggle column that hides the toggle for rows without children.
 * - `hasChildren(row)` decides if the toggle is shown for the row.
 * - Otherwise delegates to the default MUI toggle cell renderer.
 */
export function aavoGridDetailPanelToggleCol<TRow extends object>(
	hasChildren: (row: TRow) => boolean,
): FlattenedAavoGridColDef<TRow> {
	const base = GRID_DETAIL_PANEL_TOGGLE_COL_DEF as GridColDef<TRow>;
	const renderCell = (params: GridRenderCellParams<TRow>) => {
		if (!hasChildren(params.row)) return null;
		return base.renderCell?.(params);
	};

	return {
		...base,
		renderCell,
	};
}
